<template>
  <a-modal
    v-model:visible="visible"
    title="转换图片"
    width="1200px"
    style="top: 20px"
    :maskClosable="false"
    wrapClassName="image-inpainting-1688-modal"
    :closable="false"
  >
    <a-spin size="large" :spinning="loading" tip="正在加载中，请等待">
      <div class="box">
        <div class="img-box">
          <div class="left">
            <span class="title">原图</span>
            <img v-if="imgObj.img" :src="imgObj.img" />
          </div>
          <div class="right">
            <span class="title">转换后的图片</span>
            <img
              v-if="image"
              :class="{ 'is-touming': image && currentType === 2 }"
              :src="image"
            />
          </div>
        </div>
      </div>
    </a-spin>
    <template #footer>
      <a-button
        v-for="item in typeArr"
        type="primary"
        :loading="loading"
        :key="item.formatType"
        @click="changeImage(item)"
        >转换成{{ item.label }}</a-button
      >
      <a-button
        type="primary"
        :disabled="!image"
        :loading="loading"
        @click="changeImageAndCloseModal"
        >替换原图并关闭窗口</a-button
      >
      <a-button
        type="primary"
        danger
        :loading="loading"
        @click="visible = false"
        >关闭窗口</a-button
      >
    </template>
  </a-modal>
</template>
<script>
import api from "./api";
import {
  GetAkData,
  UploadImage3,
} from "@/views/moving_function/views/shipping_preview_list/bos_config";

import imgUtil from "@/views/moving_function/utils/img";
export default {
  data() {
    return {
      visible: false,
      imgObj: {},
      image: "",
      typeArr: [
        { formatType: 1, label: "白底图" },
        { formatType: 2, label: "透明图" },
      ],
      currentType: "",
      loading: false,
    };
  },
  methods: {
    async changeImage(item) {
      if (!this.imgObj.img)
        return this.$message.warning("当前没有图片 ..... 请重试");
      let img = this.imgObj.img;
      // 如果是base64，需要先上传到百度云，拿到图片链接后再进行转换图片
      if (this.imgObj.isUpdate && img.includes("data:image")) {
        // --------- 上传到百度云前验证开始 ---------
        await GetAkData();
        // --------- 上传到百度云前验证结束 ---------
        const file = await imgUtil.Base64ToFile(img);
        if (!file) return this.$message.warning("base64 转换成 文件失败");
        img = await UploadImage3(file);
      }
      if (!img) return this.$message.warning("接口获取图片链接失败");
      this.loading = true;
      const { success, msg, imageUrl } = await api.OperateImageTo1688({
        imageUrl: img,
        formatType: item.formatType,
      });
      const str = `转换成${item.label}`;
      if (!success) {
        this.loading = false;
        return this.$message.warning(`${str}失败，原因:【${msg}】`);
      }
      this.currentType = item.formatType;
      this.$message.success(`${str}成功`);
      this.loading = false;
      this.image = "data:image/jpeg;base64," + imageUrl;
      this.imgObj.isUpdate = true;
    },
    changeImageAndCloseModal() {
      this.imgObj.img = this.image;
      this.visible = false;
      this.$message.success("替换原图成功");
      this.$emit("change-image", this.image);
    },
  },
  watch: {
    visible(value) {
      if (!value) {
        this.image = this.currentType = "";
      }
    },
  },
};
</script>
<style lang="less">
.image-inpainting-1688-modal {
  .ant-modal-header {
    padding: 9px 20px;
  }
  .ant-modal-body {
    padding: 6px 0;
  }
}
</style>
<style scoped lang="less">
@import "./index";
</style>
